import { loadingFalse } from "../Reducer/loaderSlice";
import ApiCall from "./ApiCall";
import { deleteAllCookies, reloadWindow } from "./Utils";

const Handler = async ({ method, url, data = {}, headers = {} }) => {
    let responseData = {};
    try {
        const response = await ApiCall({ url, method, data, headers });
        
        // Zip file or Binary data (PDF/Excel) handling
        if (headers['Content-Type'] === 'application/zip' || response instanceof Blob) {
            responseData['status'] = true;
            responseData['data'] = response;
        } else if (response.status || response.success) {
            responseData['status'] = true;
            responseData['data'] = response;
        } else {
            responseData['status'] = false;
            responseData['data'] = response;
        }
    } catch (error) {
        responseData['status'] = false;
        responseData['data'] = error?.response?.data || { message: "Retry after sometime" };
        loadingFalse();
        return { success: false, message: responseData['data']?.message || "Server Error" };

    } finally {
        let { status, data } = responseData;

        // Session Expiry handling (401 - Unauthorized)
        if (data?.status == 401 || data?.status == 504) {
            deleteAllCookies();
            reloadWindow();
        }

        if (status === true) {
            return {
                success: true,
                data: data?.data || data, 
                message: data?.msg || data?.message,
                token: data?.token,
                
                // Pagination Fields
                pagination: data?.pagination || null,
                page: data?.pagination?.page || data?.page || data?.current_page || 1,
                total: data?.pagination?.total_rows || data?.total || data?.total_count || data?.total_pages || 0,
                total_count: data?.total_count || data?.pagination?.total_rows || data?.total || 0,
                limit: data?.pagination?.limit || data?.limit,
                total_records: data?.total_records || 0,

                // Analytics & Summary Fields
                summary: data?.summary || null,
                summary_cards: data?.summary_cards || null,
                kpi_summary: data?.kpi_summary || null,
                
                // List Mappings (Specific for Revenue and Dispatch reports)
                invoice_list: data?.invoice_list || null, // ⭐ Revenue report-ku idhu thevai
                dispatch_list: data?.dispatch_list || null,
                
                // Chart Data support
                revenue_chart: data?.revenue_chart || null, // ⭐ Monthly Revenue chart mapping
                status_chart: data?.status_chart || null,
                driver_chart: data?.driver_chart || null,
                invoice_status_chart: data?.invoice_status_chart || null,
                vehicle_utilization_chart: data?.vehicle_utilization_chart || null,
                vehicle_chart: data?.vehicle_chart || null,
                customer_trend_chart: data?.customer_trend_chart || null,
                
                filters: data?.filters || null
            };
        } else {
            return { 
                success: false, 
                message: data?.msg || data?.message || "Something went wrong" 
            };
        }
    }
};

export default Handler;